import React from 'react';

import cn from 'classnames';

import { Flex, UiText } from '@shared/ui';
import { DraggableEl } from '@widgets/OrdersRecognition/ui/Order/DraggableEl';

import cls from './OrderDragPreview.module.css';

interface IOrderDragPreviewProps {
    name: string;
}

export const OrderDragPreview = ({ name }: IOrderDragPreviewProps) => (
    <Flex className={cn(cls.OrderDragPreview)} gap={8}>
        <DraggableEl />
        <UiText variant="mediumPlain" tag="span">
            {name}
        </UiText>
    </Flex>
);
